
const state = {
  currCustomer: {},
  currDcpRoles: [],
  currApps: {},
  theme: 'nt'
}

const mutations = {
  SET_CURR_CUSTOMER: (state, data) => {
    state.currCustomer = data
  },
  SET_CURR_ROLES: (state, data) => {
    state.currDcpRoles = data
  },
  SET_CURR_APPS: (state, data) => {
    state.currApps = data
  },
  SET_THEME: (state, data) => {
    state.theme = data
  }

}

const actions = {
  SET_CURR_CUSTOMER({ commit }, data) {
    commit('SET_CURR_CUSTOMER', data)
  },
  SET_CURR_ROLES({ commit }, data) {
    commit('SET_CURR_ROLES', data)
  },
  SET_CURR_APPS({ commit }, data) {
    commit('SET_CURR_APPS', data)
  },
  SET_THEME({ commit }, data) {
    commit('SET_THEME', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
